import { getTypeOrdredChildLinks, ChildType } from '../../utils/children';

export const getCategoryLabel = (labels) => {
  const label = labels.find(({ type }) => type === ChildType.DISTANCE);
  if (label) {
    return label.value;
  }
  return '';
};

export const getParentLinks = (parents) =>
  parents && parents.length
    ? parents
        .map((parent) =>
          getTypeOrdredChildLinks(parent, [
            ChildType.LOCATION,
            ChildType.DISTANCE,
          ]),
        )
        .filter(({ text, link }) => !!text && !!link)
        .reverse()
    : [];
